"use client";

import React, { useState, useEffect, use } from "react";
import AccordionItem from "./AccordionItem";
import { useScrollToHash } from "@/helpers/useScrollToHash";

const Accordion = ({ id, title, items, cards, menu, slideEffect }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const hashIndex = useScrollToHash(items, "accordion");
  const [hash, setHash] = useState(null);

  const initialHash =
    typeof window !== "undefined" ? window.location.hash.slice(1) : "";

  useEffect(() => {
    if (typeof window !== "undefined") {
      const updateHash = () => {
        setHash(window.location.hash.slice(1));
      };

      setHash(window.location.hash.slice(1));
      window.addEventListener("hashchange", updateHash);

      return () => {
        window.removeEventListener("hashchange", updateHash);
      };
    }
  }, []);

  // on load/hash-change, open the linked item
  // useEffect(() => {
  //   if (hashIndex !== null) {
  //     setActiveIndex(hashIndex);
  //   }
  // }, [hashIndex]);

  useEffect(() => {
    if (!hash && !initialHash) return;
    const interval = setInterval(() => {
      if (window.$ && window.$.fn && window.$.fn.foundation) {
        clearInterval(interval);
      }

      if (typeof window === "undefined" || !window.$) return;
      const $ = window.$;
      // if (!items || !items.length) return;

      console.log("initialHash: ", initialHash);
      const accordionelement = document.querySelector(
        `a[name="${initialHash}"]`
      );
      if (!accordionelement) return;
      const accordion = accordionelement.parentElement.parentNode;
      const accordionContent = document.querySelector(
        `a[name="${initialHash}"]`
      ).nextSibling;

      console.log("accordion: ", accordion);
      console.log("accordionContent: ", accordionContent);

      if (accordion && accordionContent) {
        $(accordion).foundation("down", $(accordionContent));
        // setActiveIndex(
        //   parseInt(accordion.getAttribute("data-index"), 10) || null
        // );
      }
    }, 100);

    return () => clearInterval(interval);
  }, [hash, initialHash]);

  // const handleClick = (index) => {
  //   setActiveIndex((prev) => (prev === index ? null : index));
  // };

  return (
    <>
      {title && <h3>{title}</h3>}
      <div className="tps-accordion-wrapper cell margin-bottom-3g">
        <ul
          className="accordion tps-accordion"
          data-accordion=""
          data-allow-all-closed="true"
          data-deep-link="true"
          data-slide-speed={`${slideEffect === true ? 275 : 0}`}
          data-update-history="true"
          id={`accordion-${title?.trim().replace(/[\s?]+/g, "")}-${id}`}
          role="tablist"
        >
          {items &&
            items.map((item, index) => {
              if (
                (item.nested?.data !== null &&
                  item.nested?.data?.attributes?.publishedAt !== null) ||
                item?.text ||
                item?.buttonText
              ) {
                return (
                  <AccordionItem
                    accordionHtmlHack={item?.accordionHtmlHack}
                    key={index}
                    id={index}
                    isActive={activeIndex === index}
                    // onClick={() => handleClick(index)}
                    menu={menu}
                    title={item?.title}
                    subtitle={item?.subtitle}
                    text={item?.text}
                    buttonPage={item?.buttonPage}
                    buttonUrl={item?.buttonUrl}
                    buttonText={item?.buttonText}
                    cardItems={cards}
                    videoUrl={item?.videoUrl}
                    videoUrl2={item?.videoUrl2}
                    slideEffect={slideEffect}
                    targetBlank={item?.targetBlank}
                    nested={item?.nested}
                    name={item?.name}
                  />
                );
              }
            })}
        </ul>
      </div>
    </>
  );
};

export default Accordion;
